import { formatCarouselItemsToBE } from '../formatCarouselItemsToBE'
import { formatSingleItemToBE } from '../formatSingleImageOrVideoToBE/formatSingleItemToBE'

import { STORIES_ITEMS } from '../../../../../fields'

import { FormatStoriesItemsToBEParams, FormattedStoriesItems } from './types'

export const formatStoriesItemsToBE = ({ values, tags }: FormatStoriesItemsToBEParams): FormattedStoriesItems => {
  const { [STORIES_ITEMS]: storiesItems } = values

  const storyItemValues = storiesItems[0]

  const preparedValues = { ...values, ...storyItemValues }

  if (storiesItems.length === 1) {
    return formatSingleItemToBE({ values: preparedValues, tags })
  } else {
    return formatCarouselItemsToBE({ values, items: storiesItems, tags })
  }
}
